(() => {
  const instances = new Map();

  class CtrScienceLayers {
    constructor(section) {
      this.section = section;
      this.sectionId = section.dataset.sectionId || "";
      this.items = Array.from(section.querySelectorAll("[data-ctr-layer-item]"));
      this.allowMultiple = section.dataset.allowMultiple === "true";

      this.handleToggleClick = this.handleToggleClick.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onSectionSelect = this.onSectionSelect.bind(this);
      this.onResize = this.onResize.bind(this);

      this.bind();
      this.syncHeights();
    }

    bind() {
      this.items.forEach((item) => {
        const button = item.querySelector("[data-ctr-layer-toggle]");
        if (!button) return;
        button.addEventListener("click", this.handleToggleClick);
      });

      window.addEventListener("resize", this.onResize);
      document.addEventListener("shopify:section:select", this.onSectionSelect);
      document.addEventListener("shopify:section:deselect", this.onSectionSelect);
      document.addEventListener("shopify:block:select", this.onBlockSelect);
    }

    handleToggleClick(event) {
      event.preventDefault();
      const item = event.currentTarget.closest("[data-ctr-layer-item]");
      if (!item) return;

      const isOpen = item.classList.contains("is-open");

      if (!this.allowMultiple) {
        this.items.forEach((otherItem) => {
          if (otherItem === item) return;
          this.closeItem(otherItem);
        });
      }

      if (isOpen) {
        this.closeItem(item);
        return;
      }

      this.openItem(item);
    }

    onSectionSelect(event) {
      const detail = event.detail || {};
      if (detail.sectionId !== this.sectionId) return;
      this.syncHeights();
    }

    onBlockSelect(event) {
      const detail = event.detail || {};
      if (detail.sectionId !== this.sectionId || !detail.blockId) return;

      const item = this.items.find((entry) => entry.dataset.blockId === detail.blockId);
      if (!item) return;

      if (!this.allowMultiple) {
        this.items.forEach((otherItem) => {
          if (otherItem === item) return;
          this.closeItem(otherItem);
        });
      }

      this.openItem(item);
    }

    onResize() {
      this.syncHeights();
    }

    openItem(item) {
      const button = item.querySelector("[data-ctr-layer-toggle]");
      const body = item.querySelector("[data-ctr-layer-body]");
      if (!button) return;

      item.classList.add("is-open");
      button.setAttribute("aria-expanded", "true");
      if (body) {
        body.style.maxHeight = `${body.scrollHeight}px`;
      }
    }

    closeItem(item) {
      const button = item.querySelector("[data-ctr-layer-toggle]");
      const body = item.querySelector("[data-ctr-layer-body]");
      if (!button) return;

      if (body) {
        body.style.maxHeight = `${body.scrollHeight}px`;
      }

      item.classList.remove("is-open");
      button.setAttribute("aria-expanded", "false");

      requestAnimationFrame(() => {
        if (body) {
          body.style.maxHeight = null;
        }
      });
    }

    syncHeights() {
      this.items.forEach((item) => {
        if (!item.classList.contains("is-open")) return;
        const body = item.querySelector("[data-ctr-layer-body]");
        if (!body) return;
        body.style.maxHeight = `${body.scrollHeight}px`;
      });
    }

    destroy() {
      this.items.forEach((item) => {
        const button = item.querySelector("[data-ctr-layer-toggle]");
        if (!button) return;
        button.removeEventListener("click", this.handleToggleClick);
      });

      window.removeEventListener("resize", this.onResize);
      document.removeEventListener("shopify:section:select", this.onSectionSelect);
      document.removeEventListener("shopify:section:deselect", this.onSectionSelect);
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }
  }

  const init = (root) => {
    const section = root?.querySelector?.(".ctr-science-layers") || root;
    if (!section || !section.matches(".ctr-science-layers")) return;
    if (instances.has(section)) return;
    instances.set(section, new CtrScienceLayers(section));
  };

  const unload = (root) => {
    const section = root?.querySelector?.(".ctr-science-layers") || root;
    if (!section || !section.matches(".ctr-science-layers")) return;
    const instance = instances.get(section);
    if (!instance) return;
    instance.destroy();
    instances.delete(section);
  };

  const initAll = () => {
    document.querySelectorAll(".ctr-science-layers").forEach((section) => init(section));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:section:unload", (event) => unload(event.target));
  document.addEventListener("shopify:section:reorder", initAll);
})();
